import { Component, OnInit, Input } from '@angular/core';
import { UIRouter } from '@uirouter/core';
import { CheckoutService } from '../checkout.service';

@Component({
  templateUrl: './success.component.html',
  styleUrls: [
    './success.component.scss'
  ]
})
export class CheckoutSuccessComponent implements OnInit {
  public buttonCount: number;
  public wasLoggedIn: boolean;
  public isNewUser: boolean;
  public hasOnlyGifts: boolean = false;

  @Input()
  public stateParams;

  constructor(
    private router: UIRouter,
    private checkoutService: CheckoutService
  ) {

  }

  public ngOnInit() {
    if (!this.stateParams.success) {
      this.router.stateService.go('main.checkout.index');
    }

    this.buttonCount = this.stateParams.buttonCount;
    this.wasLoggedIn = this.stateParams.wasLoggedIn;
    this.isNewUser = this.stateParams.isNewUser;
    this.hasOnlyGifts = this.stateParams.onlyGifts;
    
    if (window.localStorage.getItem('checkoutItems')) {
      window.localStorage.removeItem('checkoutItems');
    }
  }
}


// WEBPACK FOOTER //
// ./src/app/checkout/success/success.component.ts